// src/components/FooterComponent.jsx
import React, { useState } from 'react';
import '../global.css';

const FooterComponent = () => {
  const [modalContent, setModalContent] = useState(null);
  const [showGdprModal, setShowGdprModal] = useState(false);

  const openModal = (type) => {
    let content = '';
    if (type === 'about') {
      content = (
        <>
          <p>
            This website is a free web-based platform created by a volleyball coach to help other
            coaches and players manage their teams more effectively. It allows users to create and
            organize teams, add and manage players, and monitor individual player progress over
            time. The platform is designed to support coaching decisions by providing a clear and
            structured overview of each player's development.
          </p>
          <p>
            This website is offered free of charge and continues to evolve through ongoing
            development. To keep it running, it relies on community support and donations. If you
            find it helpful, your support is greatly appreciated!
          </p>

          {/* Link on its own line */}
          <div style={{ marginTop: '1.5rem' }}>
            <button
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                color: '#2563EB',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
              onClick={() => setShowGdprModal(true)}
            >
              In the EU? Click Here
            </button>
          </div>
        </>
      );
    } else if (type === 'terms') {
      content = (
        <p>
          This application is provided free of charge and is currently under active development.
          While every effort is made to ensure functionality and security, the developer assumes no
          responsibility for any loss, damage, or data corruption that may occur from using this
          app. Users agree to use the app at their own risk.
        </p>
      );
    }
    setModalContent(content);
  };

  const closeModal = () => setModalContent(null);
  const closeGdprModal = () => setShowGdprModal(false);

  return (
    <>
      <footer
        className="footer mt-4"
        style={{
          padding: '1rem',
          textAlign: 'center',
          fontSize: '0.9rem',
          background: '#F3F4F6',
          borderTop: '1px solid #D1D5DB'
        }}
      >
        <span
          className="footer-link"
          onClick={() => openModal('about')}
          style={{ marginRight: '1rem', cursor: 'pointer', color: '#2563EB' }}
        >
          About
        </span>
        <span
          className="footer-link"
          onClick={() => openModal('terms')}
          style={{ marginRight: '1rem', cursor: 'pointer', color: '#2563EB' }}
        >
          Terms and Conditions
        </span>
        <span className="footer-link" style={{ cursor: 'pointer', color: '#2563EB' }}>
          Donate
        </span>
      </footer>

      {/* Standard modal */}
      {modalContent && (
        <div
          className="modal-overlay"
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff',
              padding: '2rem',
              borderRadius: '8px',
              width: '90%',
              maxWidth: '500px',
              textAlign: 'left',
              boxShadow: '0 0 10px rgba(0,0,0,0.2)'
            }}
          >
            {modalContent}
            <button
              className="btn-secondary mt-2"
              onClick={closeModal}
              style={{ marginTop: '1rem' }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* GDPR modal */}
      {showGdprModal && (
        <div
          className="modal-overlay"
          onClick={closeGdprModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000
          }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff',
              padding: '2rem',
              borderRadius: '8px',
              width: '90%',
              maxWidth: '800px',
              textAlign: 'left',
              maxHeight: '80vh',
              overflowY: 'auto',
              boxShadow: '0 0 10px rgba(0,0,0,0.2)'
            }}
          >
            <h2>GDPR Privacy Policy</h2>
            <pre style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
              {`1. Who We Are
VolleyCoach (“we”, “our”, “us”) is an online volleyball coaching platform designed to help players improve their skills through training plans, performance tracking, and communication with coaches.

We are committed to protecting your personal information and respecting your privacy in accordance with the UK General Data Protection Regulation (“GDPR”) and EU GDPR where applicable.

2. What Information We Collect
We only collect the information we need to operate the app and provide our services. This may include:

Account Information: Name, email address, password
Player Profile Data: Position, shirt number, skill progress, performance statistics
Technical Information: IP address, browser type, device information (for security and troubleshooting)
Photos: Profile picture (if uploaded)
Communications: Messages or feedback sent to us

We do not collect sensitive categories of data (e.g., health data) unless you provide it voluntarily.

3. How We Use Your Information
We use your personal information to:
Create and manage your account
Track your volleyball skills and progress
Provide training plans and coaching feedback
Communicate with you about your account or services
Maintain the security and functionality of the app
Improve our platform and user experience
Comply with legal obligations

4. Legal Bases for Processing
Under GDPR, we process your personal data based on one or more of the following:
Consent – You have given clear consent for us to process your data for a specific purpose.
Contract – Processing is necessary for the performance of our service agreement with you.
Legal Obligation – Processing is required by law.
Legitimate Interests – Processing is necessary for our legitimate business purposes, provided your rights are not overridden.

5. How We Store and Protect Your Data
All communication is encrypted via HTTPS.
Passwords are stored securely using bcrypt hashing.
Data is stored on GDPR-compliant hosting providers.
Access to personal data is restricted to authorised personnel only.
Regular backups are encrypted and stored securely.

6. How Long We Keep Your Data
We keep your personal data only for as long as necessary to provide our services or as required by law.
If you delete your account, we will remove your personal data from our active systems within 30 days and from backups within 90 days.

7. Sharing Your Data
We do not sell your personal data.
We may share your data with trusted third-party service providers who help us operate the app (e.g., hosting, email delivery, analytics), and only where they are GDPR-compliant.
We may also share data where required by law or to protect the rights, safety, and security of our users.

8. Your Rights Under GDPR
You have the right to:
Access – Request a copy of the personal data we hold about you.
Rectification – Correct any inaccurate or incomplete data.
Erasure – Request that we delete your personal data (“Right to be Forgotten”).
Restriction – Ask us to limit how we use your data.
Data Portability – Receive your data in a common format to move it elsewhere.
Object – Stop certain types of processing (e.g., marketing).
Withdraw Consent – Withdraw your consent at any time.

You can exercise these rights by contacting us at privacy@volleycoach.com.

9. Children’s Privacy
We do not knowingly collect personal data from children under 13 without parental consent.
If we become aware that we have collected such information without consent, we will delete it immediately.

10. Cookies & Tracking
We may use cookies or similar technologies to improve your experience. You can control or disable cookies through your browser settings.

11. Data Breach Notification
If we experience a data breach that may compromise your personal data, we will notify you and the relevant data protection authority within 72 hours, as required by law.

12. How to Contact Us
If you have any questions or requests regarding this Privacy Policy, please contact us at:
📧 privacy@volleycoach.com
You also have the right to lodge a complaint with the UK Information Commissioner’s Office (ICO) or your local data protection authority.`}
            </pre>
            <button
              className="btn-secondary mt-2"
              onClick={closeGdprModal}
              style={{ marginTop: '1rem' }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FooterComponent;
